import * as Sentry from '@sentry/browser';
import { useCookies } from 'react-cookie';

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

type GetInitialAutoMessage = {
  approved_content: string;
  has_regular_closing_day_overview_item: boolean;
};

export const useInitialAutoMessages = () => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const getInitialAutoMessages = async (companyId: number): Promise<GetInitialAutoMessage | null> => {
    const url = `${backendBasePath}/admin/companies/${companyId}/initial_auto_message`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          uid: cookies['uid'],
          client: cookies['client'],
          'access-token': cookies['access-token'],
        },
      });
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      const result: GetInitialAutoMessage = await response.json();
      return result;
    } catch (error) {
      Sentry.captureException(error);
      console.error('通信に失敗しました', error);
      return null;
    }
  };

  const postInitialAutoMessage = async (companyId: number, initialAutoMessages: string): Promise<true> => {
    const url = `${backendBasePath}/admin/companies/${companyId}/initial_auto_message`;
    const result = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        inputting_content: initialAutoMessages,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return true;
  };

  return {
    getInitialAutoMessages,
    postInitialAutoMessage,
  };
};
